/* eslint-disable react/no-unescaped-entities */
import Link from 'next/link';
import React from 'react';

const Statistic = () => {
	return (
		<div>
			{/* <!-- Statistic / Promo --> */}
			<section className="relative py-12 lg:py-36">
				<picture className="pointer-events-none absolute inset-0 -z-10 after:absolute after:bottom-0 after:h-1/3 after:w-full after:bg-gradient-to-t after:from-[#010107]">
					<img
						src="/images/gradient_creative.jpg"
						alt="gradient"
						className="h-full w-full -scale-y-100"
					/>
				</picture>
				<div className="container -mt-20 lg:pb-32">
					<h2 className="mb-12 max-w-5xl font-display text-5xl text-white lg:text-[6rem]">
						High-quality Pixel Art Assets
					</h2>
					<p className="mb-20 max-w-4xl text-3xl font-medium text-white lg:ml-36">
						We empower game developers and artists with AI generated Pixel Art. Generate on the website
						or on Gimp - no GPU required
					</p>
					<div className="grid grid-cols-2 gap-8 md:grid-cols-4">
						<div>
							
						</div>
						<div>
							
						</div>
					</div>
				</div>

				{/* <!-- Promo 1 --> */}
				<div className="container pt-32">
					<div className="items-center justify-between lg:flex">
						<div className="relative text-center lg:w-1/2">
							
							<img
								src="/images/pelgine_pixelart.png"
								alt=""
								loading="lazy"
								className="relative -top-10 inline-block"
								style={{ transform: 'scale(1.25)' }}
								

							/>
						
						</div>
						<div className="lg:w-[45%] lg:pl-16">
							<h2 className="mb-6 font-display text-2xl text-white">
								Create High Quality Pixel Art
							</h2>
							<p className="mb-8 text-lg leading-normal text-jacarta-200">
							Pelgine will produce beautiful pixel art for your next project fast.
							</p>
						</div>
					</div>
					
				</div>
			</section>
			{/* <!-- end statistic / promo --> */}
		</div>
	);
};

export default Statistic;
